require('select2')();

const ChoicesHook = {
  mounted() {
    this.selectEl = this.el.querySelector('select');

    this.initializeSelect();
  },

  isTags() {
    return this.el.dataset.tags !== undefined;
  },

  initializeSelect() {
    if (this.isInitialized()) return $(this.selectEl);

    const $selectEl = $(this.selectEl);

    $selectEl.off('change');
    $selectEl.off('select2:select');
    $selectEl.off('select2:unselect');

    // NOTE: Let's see how it wowrks, we patched LV now to ignore stale events.
    const dropdownParent =
      this.selectEl.closest("[data-ui~='dropdown-content']") ||
      this.selectEl.closest("[data-ui~='modal-container']") ||
      document.body;

    let opts = {
      templateResult: this.template('result'),
      templateSelection: this.template('selection'),
      placeholder: this.selectEl.dataset.placeholder,
      allowClear: true,
      width: '100%',
      readonly: true,
      // dropdownParent: document.body,
      dropdownParent: dropdownParent,
    };

    if (this.el.dataset.create !== undefined) {
      opts.tags = true;
    }

    if (this.isTags()) {
      opts.tags = true;
    }

    if (this.el.dataset.search !== undefined) {
      const target = this.el.dataset.target;

      opts.minimumInputLength = 1;
      opts.ajax = {
        delay: 250,
        transport: (params, success, failure) => {
          const payload = {
            term: params.data.term,
          };

          this.pushEventTo(target, 'search', payload, (reply) => {
            success(reply.hits);
          });
        },
        processResults: function (hits) {
          const items = hits.map((hit) => {
            return {
              id: hit.value,
              text: hit.key,
              source: 'data',
              data: {
                rich: hit.data_rich == 'rich',
                subtext: hit.data_subtext,
                image: hit.data_image,
              },
            };
          });

          return {
            results: items,
          };
        },
      };
    }

    const select = $(this.selectEl).select2(opts);

    if (this.multiple()) {
      // Open dropdown when focusing select input
      this.selectEl.addEventListener('focus', () => {
        $(this.selectEl).select2('focus');
        $(this.selectEl).select2('open');
      });

      // Open dropdown when focusing using TAB key
      this.selectEl.nextElementSibling
        .querySelector('.select2-selection')
        .addEventListener('focus', () => {
          $(this.selectEl).select2('focus');
          $(this.selectEl).select2('open');
        });
    }

    select.on('change', (e) => {
      this.selectEl.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Hack to not trigger change event on the form.
    // It looks like it works now (change not triggered while select2 still works) but can cause issues in future.
    this.el.querySelector('textarea')?.addEventListener('input', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  },

  isInitialized() {
    return this.selectEl.classList.contains('select2-hidden-accessible');
  },

  updated() {
    requestAnimationFrame(() => {
      this.initializeSelect();
    });
  },

  multiple() {
    return this.el.querySelector('select').multiple;
  },

  template(type) {
    return (item) => {
      if (!item.id) return item.text;

      if (this.multiple() && type == 'selection') return item.text;

      let data;

      // Creating tags
      if (type == 'result' && item.id == item.text && !item.element)
        return $(`<div>Add <span class="font-medium">${item.text}</span></div>`);

      if (item.source == 'data') {
        data = item.data;
      } else {
        if (!item.element) {
          return item.text;
        }

        data = {
          rich: item.element.dataset.rich === 'rich',
          image: item.element.dataset.image,
          subtext: item.element.dataset.subtext,
        };
      }

      if (!data.rich) return item.text;

      let imageHtml;
      if (!!data.image) {
        imageHtml = `
        <img src="${data.image}" class="flex-shrink-0 block w-12  h-12 rounded" />
        `;
      } else {
        imageHtml = `
      <div class="flex-shrink-0 w-12 h-12 bg-gray-100 text-gray-300 rounded flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      `;
      }

      return $(`
      <div class="flex cursor-pointer">
        ${imageHtml}

        <div class="ml-2 flex flex-col items-start">
          <div class="text-gray-600 font-medium">${item.text}</div>
          <div class="text-gray-500 text-sm">${data.subtext || '-'}</div>
        </div>
      </div>
    `);
    };
  },
};

export default ChoicesHook;
